module.exports = __webpack_public_path__ + "static/media/texture-wood-v.a7687f5d.jpg";